import React, { useEffect, useState } from "react";
import { Element } from "react-scroll";
import Layout from "../components/Layout/Layout";
import About from "../components/Sections/About";
import Herosection from "../components/Sections/Herosection";
import SectionHeading from "../components/Items/SectionHeading";
import Skills from "../components/Sections/Skills";
import Funfacts from "../components/Sections/Funfacts";
import Services from "../components/Sections/Services";
import Experiences from "../components/Sections/Experiences";

import Portfolios from "../components/Sections/Portfolios";
import Contact from "../components/Sections/Contact";
import AcademicDetailss from "../components/Sections/AcademicDetailss";
import TrackVisibility from "react-on-screen";

function Homepage() {
  const [activeTab, setActiveTab] = useState("experience");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout>
      <Element name="section-home">
        <Herosection />
      </Element>

      <Element name="section-about">
        <section className="shadow-blue white-bg padding">
          <SectionHeading title="About Me" />
          <About />
        </section>
      </Element>

      <Element name="section-skills">
        <section className="shadow-blue white-bgg padding">
          <SectionHeading title="My skills" />
          <TrackVisibility>
            <Skills />
          </TrackVisibility>
        </section>
      </Element>

      <Element name="section-funfacts">
        <Funfacts />
      </Element>

      <Element name="section-services">
        <section className="shadow-blue white-bgg padding">
          <SectionHeading title="Expertise" />
          <Services />
        </section>
      </Element>

      {/* <Element name="section-experience">
        <section className="shadow-blue white-bg padding">
          <SectionHeading title="Experience" />
          <Experiences />
          <SectionHeading title="Academic" />
          <AcademicDetailss />
        </section>
      </Element> */}
      {/* <Element name="section-experience">
        <section className="shadow-blue white-bg padding">
          <div className="mt-0 mb-5 space-left2">
            <button
              className={`resumebtn mr-3 ${activeTab === "experience"
                ? "active"
                : "resumebtn-active"
                }`}
              onClick={() => handleTabClick("experience")}
            >
              Experience
            </button>
            <button
              className={`resumebtn mr-3 ${activeTab === "academic"
                ? "active"
                : "resumebtn-active"
                }`}
              onClick={() => handleTabClick("academic")}
            >
              Academic
            </button>
          </div>
          {activeTab === "experience" && (
            <div>
              <SectionHeading title="Experience" />
              <Experiences />
            </div>
          )}
          {activeTab === "academic" && (
            <div>
              <SectionHeading title="Academic" />
              <AcademicDetailss />
            </div>
          )}
        </section>
      </Element> */}
      <Element name="section-experience">
        <section className="shadow-blue white-bg padding">
          <div className="mt-0 mb-5 space-left2">
            <button
              className={`button-91 mr-3 ${activeTab === "experience"
                ? "active"
                : "button-92"
                }`}
              onClick={() => handleTabClick("experience")}
            >
              Experience
            </button>
            <button
              className={`button-91 mr-3 ${activeTab === "academic"
                ? "active"
                : "button-92"
                }`}
              onClick={() => handleTabClick("academic")}
            >
              Academic
            </button>
          </div>
          {activeTab === "experience" && (
            <div>
              <SectionHeading title="Experience" />
              <Experiences />
            </div>
          )}
          {activeTab === "academic" && (
            <div>
              <SectionHeading title="Academic" />
              <AcademicDetailss />
            </div>
          )}
        </section>
      </Element>

      {/* <Element name="section-academic">
        <section className="shadow-blue white-bg padding">
          <SectionHeading title="Academic" />
          <AcademicDetailss />
        </section>
      </Element> */}

      <Element name="section-portfolios">
        <section className="shadow-blue white-bg padding">
          <SectionHeading title="Portfolio" />
          <Portfolios />
        </section>
      </Element>

      {/* <Element name="section-pricing">
        <section className="shadow-blue white-bg padding">
          <SectionHeading title="Pricing table" />
          <PricingTable />
        </section>
      </Element> */}

      {/* <Element name="section-testimonials">
        <section className="shadow-blue white-bg padding">
          <SectionHeading title="Testimonials" />
          <Testimonials />
        </section>
      </Element> */}

      {/* <Element name="section-clients">
        <Clients />
      </Element> */}

      {/* <Element name="section-blogs">
        <section className="shadow-blue white-bg padding">
          <SectionHeading title="Recent posts" />
          <Blogs />
        </section>
      </Element> */}

      <Element name="section-contact">
        <section className="shadow-blue white-bg padding">
          <SectionHeading title="Get in touch" />
          <Contact />
        </section>
      </Element>
    </Layout>
  );
}

export default Homepage;
